import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Nillable } from '@web/utils';
import { WarehouseRestockType } from '../../enums/warehouse-restock-type';
import { WarehouseRestockPersonRequest } from './warehouse-restock-person.request';
import { WarehouseRestockProductRequest } from './warehouse-restock-product.request';
import { WarehouseFileRequest } from './warehouse-file.request';
import { dateWithOffsetSerializer } from '@web/common';

@jsonObject
export class WarehouseRestockCreateRequest {
  @jsonMember(Date, { serializer: dateWithOffsetSerializer() })
  public readonly restockedAt!: Date;

  @jsonMember(String)
  public readonly type!: WarehouseRestockType;

  @jsonMember(WarehouseRestockPersonRequest)
  public readonly person!: WarehouseRestockPersonRequest;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonMember(String)
  public readonly shippingNumber?: Nillable<string>;

  @jsonArrayMember(WarehouseRestockProductRequest)
  public readonly goods: WarehouseRestockProductRequest[];

  @jsonArrayMember(WarehouseFileRequest)
  public readonly files?: Nillable<WarehouseFileRequest[]>;

  public constructor(data: {
    restockedAt: Date;
    comment?: Nillable<string>;
    type: WarehouseRestockType;
    person: WarehouseRestockPersonRequest;
    shippingNumber: Nillable<string>;
    products: WarehouseRestockProductRequest[];
    files?: Nillable<WarehouseFileRequest[]>;
  }) {
    this.restockedAt = data.restockedAt;
    this.comment = data.comment;
    this.type = data.type;
    this.person = data.person;
    this.shippingNumber = data.shippingNumber;
    this.goods = data.products;
    this.files = data.files;
  }
}
